<template>
  <div class="luna-matcher">
    <div class="luna-matcher__header">
      <step-indicator
        :currentStep="currentStep"
        :numberedSteps="numberedSteps"
        @step-clicked="handleSteps"
      />
    </div>

    <div class="luna-matcher__body">
      <face
        v-if="currentStep === 0 && !loading"
        ref="faceStepRef"
        @next-step="nextStep"
        :luna-master-account-options="lunaMasterAccountOptions"
        :luna-list-options="lunaListOptions"
      />

      <matcher
        v-if="currentStep === 1 && !loading"
        ref="matcherStepRef"
        :luna-master-account-id="lunaMasterAccountSelected"
        :face="face"
      />
    </div>
  </div>
</template>

<script>
import StepIndicator from "./StepIndicator.vue";
import Face from "./Face.vue";
import Matcher from "./Matcher.vue";
import store from "@/store";
import { ref, computed } from "@vue/composition-api";
import { useUtils as useI18nUtils } from "@core/libs/i18n";

export default {
  components: {
    StepIndicator,
    Face,
    Matcher,
  },
  props: {},
  setup() {
    const { t } = useI18nUtils();

    const currentStep = ref(0);
    const numberedSteps = computed(() => [
      t("luna.face_search.register"),
      t("luna.face_search.find"),
    ]);

    store.dispatch("luna_master_account/getAll");
    const lunaMasterAccountOptions = computed(
      () => store.getters["luna_master_account/getSelectedItems"]
    );

    store.dispatch("luna_list/getAll");
    const lunaListOptions = computed(() => store.getters["luna_list/getSelectedItems"]);

    const loading = ref(false);
    const face = ref(null);
    const lunaMasterAccountSelected = ref(null);

    const nextStep = (data) => {
      face.value = data.face;
      lunaMasterAccountSelected.value = data.lunaMasterAccountId;
      loading.value = false;
      currentStep.value++;
    };

    const handleSteps = async (step) => {
      currentStep.value = step;
    };

    return {
      face,
      currentStep,
      numberedSteps,
      nextStep,
      loading,

      lunaMasterAccountOptions,
      lunaListOptions,
      lunaMasterAccountSelected,

      handleSteps,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables/_variables.scss";

.luna-matcher {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.luna-matcher__header {
  flex: 0 0 auto;
  padding: 0.25rem 1rem 0.5rem;
  border-bottom: 1px solid #ebe9f1;

  .dark-layout & {
    border-bottom-color: $theme-dark-border-color;
  }
}

.luna-matcher__body {
  flex: 1 1 0;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
